import { Link } from "@tanstack/react-router";
import { STATS_TEXT } from "@/lib/stats";
import { Picture } from "@/components/site/Picture";
import { BRAND, NAV } from "@/lib/brand";
import { PILLARS } from "@/lib/pillars";
import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";


export function Footer() {
  return (
    <footer className="bg-surface">
      <div aria-hidden className="h-px bg-gradient-to-r from-transparent via-foreground/15 to-transparent" />

      <div className="container-edge py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-4">
          <Picture
            src={BRAND.logos.onDark}
            alt="Kristan Cole Network"
            className="h-20 w-auto mb-6"
            width={360}
            height={80}
            loading="lazy"
          />
          <p className="text-base text-foreground leading-relaxed max-w-sm font-display">
            Lead like a CEO. Build wealth that lasts.
          </p>
          <p className="mt-2 font-display italic text-foreground/80 text-base max-w-sm">
            Decide to do what others won't.
          </p>
          <p className="mt-5 text-sm text-foreground/65 max-w-sm leading-relaxed">
            A national network of KW brokerages led by Kristan Cole - 
            recruiting growing agents across {STATS_TEXT.markets} markets nationwide.
          </p>
          <div className="flex items-center gap-4 mt-6 text-foreground/65">
            <a href={BRAND.socials.instagram} aria-label="Instagram" target="_blank" rel="noopener noreferrer" className="hover:text-primary"><Instagram className="h-5 w-5" /></a>
            <a href={BRAND.socials.facebook} aria-label="Facebook" target="_blank" rel="noopener noreferrer" className="hover:text-primary"><Facebook className="h-5 w-5" /></a>
            <a href={BRAND.socials.linkedin} aria-label="LinkedIn" target="_blank" rel="noopener noreferrer" className="hover:text-primary"><Linkedin className="h-5 w-5" /></a>
            <a href={BRAND.socials.youtube} aria-label="YouTube" target="_blank" rel="noopener noreferrer" className="hover:text-primary"><Youtube className="h-5 w-5" /></a>
          </div>
        </div>

        <div className="md:col-span-2">
          <p className="eyebrow mb-5">Explore</p>
          <ul className="space-y-3 text-sm">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-foreground/90 hover:text-foreground">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="eyebrow mb-5">Inside KCN</p>
          <ul className="space-y-3 text-sm">
            {PILLARS.map((p) => (
              <li key={p.slug}>
                <Link to={p.path} className="text-foreground/90 hover:text-foreground">
                  {p.title} {p.italic}
                </Link>
              </li>
            ))}
            <li>
              <a
                href="https://kcnstore.printful.me/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground/90 hover:text-foreground"
              >
                KCN Brand Store
              </a>
            </li>
          </ul>
        </div>


        <div className="md:col-span-3">
          <p className="eyebrow mb-5">Start Here</p>
          <ol className="space-y-3 text-sm">
            <li>
              <a className="text-foreground/90 hover:text-foreground" href={BRAND.links.visibilityAudit}>
                <span className="text-foreground/50 mr-2">1.</span>Free Visibility Audit
              </a>
            </li>
            <li>
              <a className="text-foreground/90 hover:text-foreground" href={BRAND.links.roundTable}>
                <span className="text-foreground/50 mr-2">2.</span>Request Round Table Invite
              </a>
            </li>
            <li>
              <a className="text-foreground/90 hover:text-foreground" href={BRAND.links.strategyCall}>
                <span className="text-foreground/50 mr-2">3.</span>Growth Strategy Session
              </a>
            </li>
            <li className="pt-2">
              <Link className="text-foreground/90 hover:text-foreground" to="/blog">Blog &amp; Insights</Link>
            </li>
          </ol>
        </div>
      </div>

      <div className="container-edge">
        <div aria-hidden className="h-px bg-gradient-to-r from-transparent via-foreground/12 to-transparent" />
        <div className="py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-foreground/55">
          <p>© {new Date().getFullYear()} {BRAND.name}. {BRAND.kw}. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link to="/privacy" className="hover:text-foreground">Privacy Policy</Link>
            <span aria-hidden>|</span>
            <Link to="/terms" className="hover:text-foreground">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>

    </footer>
  );
}
